var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100",attrs:{"id":"members-page"}},[_c('MemberComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }